import { render, staticRenderFns } from "./PMPhasesList.vue?vue&type=template&id=2652959c&"
import script from "./PMPhasesList.vue?vue&type=script&lang=ts&"
export * from "./PMPhasesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports